export const PAINTING_NAVLINKS = "PAINTING_NAVLINKS";
export const PRODUCTS_FILTER = "PRODUCTS_FILTER";
export const SEARCH = "SEARCH";
